import React from 'react';
import { CalendarCheckIcon, MailIcon, MessageSquareIcon, PhoneIcon } from 'lucide-react';
import type { Channel } from '../../types/activity';
interface ChannelBadgeProps {
  channel: Channel;
  size?: 'sm' | 'md';
  /** 'positive' is reserved for connected calls — everything else stays clear. */
  tone?: 'positive' | 'plain';
}
const ICONS: Record<Channel, typeof PhoneIcon> = {
  call: PhoneIcon,
  sms: MessageSquareIcon,
  email: MailIcon,
  event: CalendarCheckIcon
};
export function ChannelBadge({
  channel,
  size = 'md',
  tone = 'plain'
}: ChannelBadgeProps) {
  const Icon = ICONS[channel];
  const box = size === 'sm' ? 'h-5 w-5' : 'h-7 w-7';
  const glyph = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
  return <span aria-hidden="true" className={`inline-flex shrink-0 items-center justify-center rounded-md ${box} ${tone === 'positive' ? 'bg-pos-soft text-pos' : 'bg-transparent text-ink-subtle'}`} data-id="element-48" data-mp="3lxvim6s4gnrs">
      <Icon className={glyph} data-id="element-49" data-mp="3vtq5xf7aj70w" />
    </span>;
}